import React from 'react';
import * as R from 'ramda';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import * as sowTypes from 'sow/types';
import * as currentOrg from 'sow/selectors/currentOrg';
import * as currentUser from 'sow/selectors/currentUser';
import { resourceCreate, resourceUpdate } from 'sow/store/helpers';
import { fromPlanApp } from 'sow/store/selectors';

import OrgDashboardActionButtonsOrg from 'sow/components/organisms/OrgDashboardActionButtonsOrg';

const withResourceHelpers = () => {
  const mapStateToProps = (state, props) => ({
    anniversaryDate: currentOrg.anniversaryDate(state, props),
    isStaff: currentUser.isStaff(state, props),
    orgId: fromPlanApp.orgId(state, props),
    isPlanAppIdMostRecent: fromPlanApp.isPlanAppIdMostRecent(state, props),
  });

  const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { orgId } = stateProps;
    const { planAppId } = ownProps;

    const baseUrl = `org/${orgId}/application/${planAppId}`;

    return {
      ...stateProps,
      ...ownProps,
      // Set state to: Initial Application Submitted
      submitInitial: resourceUpdate(`${baseUrl}/submit_initial`, 'planAppResp'),
      // Set state to: Update Submitted
      submitUpdate: resourceUpdate(`${baseUrl}/submit_revision`, 'planAppResp'),
      // Set state to: Unlocked For Update
      unsubmitUpdate: resourceUpdate(`${baseUrl}/unsubmit_revision`, 'planAppResp'),
      // Create new plan and set its state to: Unlocked for Update
      unlockForUpdate: resourceCreate(`${baseUrl}/revision`, 'planAppResp'),
    };
  };

  return connect(mapStateToProps, null, mergeProps);
};

const mapStateToProps = (state, props) => {
  const { submitInitial, submitUpdate, unsubmitUpdate, unlockForUpdate } = props;

  return {
    hasOpenPlanApp: fromPlanApp.hasOpenPlanApp(state, props),
    disabled: R.any(R.equals(true), [
      submitInitial.selectors.pending(state, props),
      submitUpdate.selectors.pending(state, props),
      unsubmitUpdate.selectors.pending(state, props),
      unlockForUpdate.selectors.pending(state, props),
    ]),
  };
};

const mapDispatchToProps = (
  dispatch,
  { submitInitial, submitUpdate, unsubmitUpdate, unlockForUpdate },
) => {
  return {
    onSubmitInitial: () => dispatch(submitInitial.action()),
    onSubmitUpdate: () => dispatch(submitUpdate.action()),
    onUnsubmitUpdate: () => dispatch(unsubmitUpdate.action()),
    onUnlockForUpdate: () => dispatch(unlockForUpdate.action()),
  };
};

const OrgDashboardActionButtonsOrgContainer = props => (
  <OrgDashboardActionButtonsOrg {...props} />
);

OrgDashboardActionButtonsOrgContainer.propTypes = {
  // Passed props
  planAppId: sowTypes.planAppIdType.isRequired,
  planApp: sowTypes.planAppType.isRequired,

  // Connected props
  orgId: sowTypes.orgIdType.isRequired,
  isPlanAppIdMostRecent: PropTypes.bool.isRequired,
  hasOpenPlanApp: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onSubmitInitial: PropTypes.func.isRequired,
  onSubmitUpdate: PropTypes.func.isRequired,
  onUnsubmitUpdate: PropTypes.func.isRequired,
  onUnlockForUpdate: PropTypes.func.isRequired,
};

OrgDashboardActionButtonsOrgContainer.defaultProps = {
  disabled: false,
};

export default R.compose(
  withRouter,
  withResourceHelpers(),
  connect(mapStateToProps, mapDispatchToProps),
)(OrgDashboardActionButtonsOrgContainer);
